import { render } from "./fiche.vue?vue&type=template&id=275222be&scoped=true"
import script from "./fiche.vue?vue&type=script&lang=js"
export * from "./fiche.vue?vue&type=script&lang=js"

import "./fiche.vue?vue&type=style&index=0&id=275222be&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275222be"]])

export default __exports__